import React from 'react';
import {
  StyledBanner,
  Body,
  CloseIcon,
  Container,
  Dismiss,
  Heading,
  StyledMarkdown,
} from './Banner.styles';

type Props = {
  dismissible?: boolean;
  heading?: string;
  body: string;
  onDismiss: () => void;
};

export function Banner({ dismissible, heading, body, onDismiss }: Props) {
  return (
    <StyledBanner>
      <Container>
        <Body>
          {heading && <Heading>{heading}</Heading>}
          {body && <StyledMarkdown text={body} />}
        </Body>
        {dismissible && (
          <Dismiss aria-label="dismiss" onClick={onDismiss}>
            <CloseIcon />
          </Dismiss>
        )}
      </Container>
    </StyledBanner>
  );
}
